require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.1@core-js/library/modules/es7.symbol.async-iterator.js
// module id = 692
// module chunks = 0